import { Dialog, Fab, FormControl, InputLabel, MenuItem, Select, Button } from '@mui/material'
import { Close } from '@mui/icons-material'
import { useState } from 'react'
import { useAlertContext } from '../context'

const AssignTypeDialog = ({ open, close, unassignedMachines, tipoMaquinas, onSave }) => {
    const [selectedMachineId, setSelectedMachineId] = useState('')
    const [selectedTypeId, setSelectedTypeId] = useState('')
    const { setAlertSimple } = useAlertContext()

    const handleSave = () => {
        if (selectedMachineId && selectedTypeId) {
            onSave(selectedMachineId, selectedTypeId)
            close()
        } else {
            setAlertSimple('Campos requeridos', 'Por favor, seleccione una máquina y un tipo.')
        }
    }

    const ordenPorTipo = (a, b) => {
        if (a.tipo > b.tipo) { return 1 }
        if (a.tipo < b.tipo) { return -1 }
        return 0
    }

    return (
        <Dialog
            open={open}
            onClose={close}
            maxWidth={'sm'}
            fullWidth
        >
            <div style={{ padding: 20 }}>
                <h1>Asignar Tipo a Máquina</h1>
                <div style={{ paddingTop: 10 }}>
                    <FormControl fullWidth style={{ marginBottom: 20 }}>
                        <InputLabel>Máquina a Configurar</InputLabel>
                        <Select
                            value={selectedMachineId}
                            onChange={(e) => setSelectedMachineId(e.target.value)}
                            label="Máquina a Configurar"
                        >
                            <MenuItem value="">
                                <em>Seleccione una máquina</em>
                            </MenuItem>
                            {unassignedMachines.map((machine) => (
                                <MenuItem key={machine._id} value={machine._id}>
                                    {machine.brand} - {machine.modelo}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>

                    <FormControl fullWidth style={{ marginBottom: 20 }}>
                        <InputLabel>Nuevo Tipo</InputLabel>
                        <Select
                            value={selectedTypeId}
                            onChange={(e) => setSelectedTypeId(e.target.value)}
                            label="Nuevo Tipo"
                        >
                            <MenuItem value="">
                                <em>Seleccione un tipo</em>
                            </MenuItem>
                            {tipoMaquinas.sort(ordenPorTipo).map((t) => (
                                <MenuItem key={t._id} value={t._id}>
                                    {t.tipo}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </div>

                <div style={{ textAlign: 'right', marginTop: 20 }}>
                    <Button onClick={close} style={{ marginRight: 10 }}>
                        Cancelar
                    </Button>
                    <Button onClick={handleSave} variant="contained" color="primary" disabled={!selectedMachineId || !selectedTypeId}>
                        Guardar
                    </Button>
                </div>

                <Fab onClick={close} style={{ position: 'absolute', right: 10, top: 10, boxShadow: 'none', backgroundColor: 'transparent' }}>
                    <Close style={{ color: '#ccc' }} />
                </Fab>
            </div>
        </Dialog>
    )
}

export default AssignTypeDialog
